<script setup lang="ts">
/**
 * Survey-frame signature element (round 2, spec "Signature elements #1").
 *
 * Wraps key imagery with 4 corner ticks like registration marks on a
 * survey map / Flurkarte. Applied with restraint: homepage hero screenshot,
 * demo browser mockup, feature-detail hero screenshots — nothing else.
 *
 * Ticks sit 6px outside the slotted content and never affect layout.
 */
defineProps<{
  /** Optional mono micro-label rendered top-right above the frame. */
  label?: string
}>()
</script>

<template>
  <div class="relative">
    <span
      v-if="label"
      class="absolute -top-6 right-0 font-mono text-[10px] uppercase tracking-widest text-muted select-none"
    >{{ label }}</span>
    <span
      aria-hidden="true"
      class="pointer-events-none absolute -top-1.5 -left-1.5 w-3.5 h-3.5 border-t-2 border-l-2 border-current text-primary/60"
    />
    <span
      aria-hidden="true"
      class="pointer-events-none absolute -top-1.5 -right-1.5 w-3.5 h-3.5 border-t-2 border-r-2 border-current text-primary/60"
    />
    <span
      aria-hidden="true"
      class="pointer-events-none absolute -bottom-1.5 -left-1.5 w-3.5 h-3.5 border-b-2 border-l-2 border-current text-primary/60"
    />
    <span
      aria-hidden="true"
      class="pointer-events-none absolute -bottom-1.5 -right-1.5 w-3.5 h-3.5 border-b-2 border-r-2 border-current text-primary/60"
    />
    <slot />
  </div>
</template>
